import {getLines, TGetLinesResponse, TXY} from "@ui/api/features"
import service from "@ui/services/features/LineService"
import {LayerId} from "@ui/services/features"
import {Feature, TFeatureConstructorParams} from "./feature"

type TLineConstructorParams = TFeatureConstructorParams

export class Line extends Feature {

  constructor(params:  TLineConstructorParams) {
    super(params)
  }

  async load(coords: TXY): Promise<void> {
    const lines = await getLines(coords)
    for (const key in lines) {
      service.addLines(lines[key as keyof TGetLinesResponse], `${key}` as LayerId)
    }
  }

  toggle(isVisible: boolean) {
    service.toggleLayer(isVisible)
  }
}
